module.exports = __webpack_public_path__ + "assets/normal-woman.svg?v=81c9645bd0e5eddea3e8b43ca9b45446";